import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { IApiCreateReportReq, IMarkoutApiDependencySegment } from '@cbridge-packages/api-markout';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkoutAction } from '../markout.action';

type IDependencies = IMarkoutApiDependencySegment;

export const createReportEpic: IEpic<{}, IDependencies> = (action$, _, { moApi }) =>
  action$.pipe(
    isTypeOfAndGetParamsAndResolver(MarkoutAction.createReport.started),
    switchMap(({ params, resolve, reject }) => {
      const apiPayload: IApiCreateReportReq = {
        name: params.name,
        settings: params.settings,
      };
      return moApi.createReport(apiPayload).pipe(
        mergeMap((response) => {
          resolve?.();
          return [
            MarkoutAction.createReport.done({
              params,
              result: { reportId: response.reportId },
            }),
            MarkoutAction.loadReports.started({}),
          ];
        }),
        catchApiError((error) => {
          const isHandled = reject?.(error.errorCode, error.description, error.params);
          return [
            MarkoutAction.createReport.failed({ params, error }),
            ...(isHandled ? [] : [createApiErrorNotification(error)]),
          ];
        }),
      );
    }),
  );
